import { useSession } from '../lib/auth-client';
import { useImpersonation } from '../lib/impersonation';

export const ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  MANAGER: 'manager',
  EMPLOYEE: 'employee',
};

export function useRole() {
  const { data, isPending } = useSession();
  const imp = useImpersonation();
  // While a superadmin is impersonating, the whole UI acts as the target
  // tenant user (their role drives the sidebar, page access, etc.).
  if (imp.active && imp.role) return imp.role;
  if (isPending) return null;
  return data?.user?.role ?? null;
}

export function isAdminRole(role) {
  return role === 'owner' || role === 'admin';
}
